import axios from "@/config/qy.axios.config";

import carrierApi from "@/api/carrier";

// 签到
export function sign(data) {
    return axios({
        method: 'post',
        url: carrierApi.signUrl,
        data
    })
};

// 签退
export function unsign(data) {
    return axios({
        method: 'post',
        url: carrierApi.unsignUrl,
        data
    })
};

// 订单列表
export function orderList(data) {
    return axios({
        method: 'post',
        url: carrierApi.orderListUrl,
        data
    })
};

// 订单状态改变
export function statusChange(data) {
    return axios({
        method: 'post',
        url: carrierApi.statusChangeUrl,
        data
    })
};

// 订单详情
export function orderDetail(data) {
    return axios({
        method: 'post',
        url: carrierApi.orderDetailUrl,
        data
    })
};

// 配送统计
export function statement(data,noLoading = false) {
    return axios({
        method: 'post',
        url: carrierApi.statementUrl,
        data,
        noLoading
    })
};

// 扫码接单
export function receive(data) {
    return axios({
        method: 'post',
        url: carrierApi.receiveUrl,
        data
    })
};

// 评论上传图片
export function uploudImg(data){
	return axios({
		method:'post',
		url:carrierApi.uploadImgUrl,
		data
	})
}
// 获取骑手状态
export function carrierStatus(data) {
    return axios({
        method: 'post',
        url: carrierApi.carrierStatusUrl,
        data
    })
};

// 查看当前订单状态
export function orderStatus(data) {
    return axios({
        method: 'post',
        url: carrierApi.orderStatusUrl,
        data
    })
};

export function orderCountlist(data) {
    return axios({
        method: 'post',
        url: carrierApi.orderCountlistUrl,
        data
    })
}